import { gql } from '@apollo/client';

export const jediUpsertAssetMutation = gql`
    mutation jediUpsertAsset(
        $symbol: String!
        $description: String
        $pictureData: String
        $pictureName: String
        $name: String!
        $figi: String!
        $marketCap: Float
    ) {
        jediUpsertAsset(input: {
            symbol: $symbol
            description: $description
            pictureData: $pictureData
            pictureName: $pictureName
            name: $name
            figi: $figi
            marketCap: $marketCap
        }) {
            asset {
                assetKey
                name
                description
                companyUrl
                pictureUrl
                symbol
            }
            success
            message
        }
    }
`;
export const jediAssetQueryBySymbol = gql`
query jediAssetQuery($symbol: String) {
    assetSearch(input: { symbol: $symbol }) {
      assets {
        assetKey
        name
        description
        companyUrl
        pictureUrl
        symbol
        figi
      }
    }
  }
`;

export const JediPopularAssetsQuery = gql`
    query AssetPopularGet {
        assetPopularGet {
            assets {
                assetKey
                assetType
                symbol
                name
                pictureUrl
            }
        }
    }
`;

export const JediYodaTradeMutation = gql`
    mutation YodaTradeMutation(
        $institutionKey: Int
        $symbol: String
        $quantity: Int
        $action: TradeAction
    ) {
        jediYodaTrade(input: { 
            institutionKey: $institutionKey,
            symbol: $symbol,
            quantity: $quantity,
            action: $action}) {
            YodaTradeResponse {
                tradeId
                portfolioId
                symbol
                marketPrice
                type
                quantity
            }
        }
    }
`;